import React from 'react';
import PropTypes from 'prop-types';

import IString from '../../i-string';

import classnames from '../../../util/classnames';

const PASSWORD_STRENGTH_MULTIPLIER = 25;

function PasswordStrengthIndicator(props) {
  const { passwordStrength } = props;

  const barColor = () => {
    switch (passwordStrength) {
      case 1:
        return 'rgb(209, 11, 97)'; //Red Color
      case 2:
        return 'rgb(232, 196, 76)'; // Yellow Color
      case 3:
        return 'rgb(180, 185, 73)'; // Olive Green
      case 4:
        return 'rgb(81, 168, 33)'; // Green 
    }
  };

  const style = {
    backgroundColor: barColor(),
    width: passwordStrength * PASSWORD_STRENGTH_MULTIPLIER + '%'
  };

  return (
    <div className="strengthOMeterFrame">
      <div className="flex flexSpaceBetween flexAlignCenter">
        <div className="somLabel"><IString stringKey='password.strength' /></div>
        <div className={classnames({ somTooWeak: passwordStrength < 2 })} />
      </div>
      <div className="somBar smallMarginAbove">
        <div className="somValueBar" style={style} />
      </div>
    </div>
  );
}

PasswordStrengthIndicator.propTypes = {
  passwordStrength: PropTypes.number
};

export default PasswordStrengthIndicator;
